import {PermissionModel} from "@core/model/aux/permission.model";
import {Action, createReducer, on} from "@ngrx/store";
import {appUserActions} from "@core/ngrx/actions"
import {AppUserModel} from "@core/model/aux/app-user.model";

export interface State {
  permissions: PermissionModel[],
  users: AppUserModel[],
}

export const initialState: State = {
  permissions: [],
  users: []
}

const userReducer = createReducer(
  initialState,
  on(appUserActions.loadPermissionsSuccess, (state, action) => {
    return {
      ...state,
      permissions: action.permissions
    }
  }),
  on(appUserActions.loadUsersSuccess, (state, action) => {
    return {
      ...state,
      users: action.users
    }
  })
);

export function reducer(state: State | undefined, action: Action): any {
  return userReducer(state, action);
}
